module.exports = __webpack_public_path__ + "img/lunbo02_02.d8e0bedf.png";